import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, Typography, TextField, DialogActions, Button, withStyles } from '@material-ui/core';

const styles = theme => ({
    buttonDanger: {
        "&$disabled": {
            backgroundColor: "gray",
            color: 'red'
        },
        color: theme.palette.buttonText.default,
        backgroundColor: 'red',
        borderRadius: '1px',

    },
    disabled: {},
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    },
    dialog: {
        backgroundColor: '#101010',
        color: 'red',
        fontWeight: 'bold'
    },
    field: {
        backgroundColor: '#585858',
        color: 'white !important',
    },
    cssLabel: {
        color: 'white'
    },
    cssOutlinedInput: {
        "&$cssFocused $notchedOutline": {
            borderColor: `red !important`,
        },
        color: "white"
    },
    cssFocused: { color: "white" },
    notchedOutline: {
        borderWidth: "1px",
        borderColor: "red !important"
    },
    disabledButton: {
        color: 'red',
        backgroundColor: 'black'
    },

});

const deleteString = "DELETE";

const DangerDelete = props => {
    let { classes, open, handleCloseDanger, handleCloseSafe, entityName, translations } = props;
    const [input, setInput] = useState('');
    const handleChange = event => {
        setInput(event.target.value);
    }

    return (
        <Dialog
            open={open}
            onClose={handleCloseSafe}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title" className={classes.dialog}>{translations['bulk_delete'] || 'Bulk delete'} {entityName}</DialogTitle>
            <DialogContent className={classes.dialog} >
                <DialogContentText className={classes.dialog}>
                    {translations['unrecoverable_action'] || 'This action is unrecoverable, please proceed only if you really know what you’re doing!'}
                    {translations['input_delete'] || 'To proceed please enter DELETE to the field:'}
                </DialogContentText >

                <Typography variant={"h6"}>{'Danger Delete'}</Typography>
                <TextField
                    className={classes.field}
                    name="DeleteInput"
                    value={input}
                    variant={'outlined'}
                    onChange={handleChange}
                    placeholder={translations['type_delete'] || 'Type delete'}
                    margin={"dense"}
                    InputLabelProps={{
                        classes: {
                            root: classes.cssLabel,
                            focused: classes.cssFocused,
                        },
                    }}
                    InputProps={{
                        classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline
                        },
                    }}
                    fullWidth={true}
                />
            </DialogContent>
            <DialogActions className={classes.dialog}>
                <Button onClick={handleCloseSafe} variant="contained" className={classes.buttonSafe}>
                    {translations['no'] || 'No'}
                </Button>
                <Button onClick={handleCloseDanger} variant="contained" classes={{ root: classes.buttonDanger, disabled: classes.disabled }} disabled={input !== deleteString}>
                    {translations['yes'] || 'Yes'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default withStyles(styles, { withTheme: true })(DangerDelete);